// Copyright Carrefour(2022)
//

import map from 'lodash-es/map'
import get from 'lodash-es/get'

import { ref } from 'vue'
import { persistFilters } from '@c4-links/vuejs-utilities/src/utils'
import useError from '@c4-links/vuejs-utilities/src/features/useError'
import useUser from '@c4-links/vuejs-utilities/src/features/useUser'
import useLooker from '@c4-links/vuejs-utilities/src/features/useLooker'
import useFilters from '@c4-links/vuejs-utilities/src/features/useFilters'
import filtersPosG40 from './filters/filtersPosG40'
import filtersPosG40Competitor from './filters/filtersPosG40Competitor'
import filtersPosG9 from './filters/filtersPosG9'
import filtersPosG9Competitor from './filters/filtersPosG9Competitor'
import filtersPosSBS from './filters/filtersPosSBS'
import filtersPosSBSCompetitor from './filters/filtersPosSBSCompetitor'

const { addError } = useError()
const { user } = useUser()
const { fetchLookData } = useLooker()
const { assignFilters } = useFilters()

const modeUnknown = 'unknown'
const modeG40Monthly = 'pos_g40'
const modeG9Weekly = 'pos_g9_std_weekly'
const modeSbsWeekly = 'pos_g9_sbs_weekly'
const modeSbsMonthly = 'pos_g9_sbs_monthly'

const mode = ref(modeUnknown)

const fecthCountryCodes = async (lookId) => {
  let country_codes = {}
  try {
    await fetchLookData({
      lookId,
      query: {
        limit: 1000
      }
    }).then(response => {
      return map(response.data, (entry) => {
        country_codes = Object.assign(country_codes, Object.fromEntries([Object.values(entry)]))
      })
    })
  } catch (err) {
    console.error(err)
    addError({
      message: 'A server error occurred, please retry later or refresh your page.',
      details: err.toString()
    })
  }
  return country_codes
}

const switchFilters = async (newMode, competitor) => {
  let f = {}
  let country_codes = {}
  let cookieName = null
  const countries = []
  const user_countries = get(user, `value.${newMode.toLowerCase()}.countries`, {})

  switch (newMode.toLowerCase()) {
    case modeG40Monthly:
      country_codes = await fecthCountryCodes(process.env.VUE_APP_LOOKID_G40_COUNTRIES || 460)
      map(user_countries, (value, key) => {
        countries.push(country_codes[key] || value.toString().toUpperCase())
      })
      if (competitor) {
        cookieName = 'Carrefour-filters-posg40-competitor'
        f = filtersPosG40Competitor()
      } else {
        cookieName = 'Carrefour-filters-posg40'
        f = filtersPosG40()
      }
      break
    case modeG9Weekly:
      country_codes = await fecthCountryCodes(process.env.VUE_APP_LOOKID_G9_COUNTRIES || 644)
      map(user_countries, (value, key) => {
        countries.push(country_codes[key] || value.toString().toUpperCase())
      })
      if (competitor) {
        cookieName = 'Carrefour-filters-posg9-competitor'
        f = filtersPosG9Competitor()
      } else {
        cookieName = 'Carrefour-filters-posg9'
        f = filtersPosG9()
      }
      break
    case modeSbsWeekly:
    case modeSbsMonthly:
      country_codes = await fecthCountryCodes(process.env.VUE_APP_LOOKID_SBS_COUNTRIES || 490)
      map(user_countries, (value, key) => {
        countries.push(country_codes[key] || value.toString().toUpperCase())
      })
      if (competitor) {
        cookieName = 'Carrefour-filters-possbs-competitor'
        f = filtersPosSBSCompetitor()
      } else {
        cookieName = 'Carrefour-filters-possbs'
        f = filtersPosSBS()
      }
      break
    default:
      cookieName = null
      throw new Error(`Unknown passed filters mode '${newMode}'`)
  }
  const savedFilters = persistFilters.loadFilters(cookieName)
  assignFilters(f, savedFilters, countries, cookieName)
}

const useMode = () => {
  return {
    modeUnknown,
    modeG40Monthly,
    modeG9Weekly,
    modeSbsWeekly,
    modeSbsMonthly,
    mode,
    switchFilters
  }
}

export default useMode
